export default __webpack_public_path__ + "static/media/Digital Keys.1f5a9c30.svg";